import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import Accordion from '../../../components/Accordion';

import "./index.scss"

import {schedule_get_all_filters} from "../../../store/actions/schedule";

import {
    Grid,
    ProgressIndicator,
    ProgressStep,
} from "carbon-components-react";

//import data from "../../../data";
class Plan extends Component {
    state = {
        isOppened2: true,
        isOppened3: false,
        isOppenedSubmit: false,
        form: {
            skuisOpened: false,
            skuDetailsisOpenend: false,
            dateStart: "",
            dateEnd: "",
            sku: [],
            brand: [],
            category: [],
            hero: [],
            majorCategory: [],
            abcd: [],
            subCategory: [],
            plcLocal: [],
            chanel: [],
        }
    };

    componentDidMount() {
        this.props.fetchData();
    }

    getFilters(data) {
        //console.log(data);
        //alert('A');
        let sku = [];
        let brand = [];
        let category = [];
        let hero = [];
        let majorCategory = [];
        let abcd = [];
        let subCategory = [];
        let plcLocal = [];

        data.forEach(dados => {
            sku.push({id: dados['sku'], text: dados['sku']});
            brand.push({id: dados['marca'], text: dados['marca']});
            category.push({id: dados['category_sku'], text: dados['category_sku']});
            hero.push({id: dados['skherou'], text: dados['hero']});
            majorCategory.push({id: dados['categoria_principal_sku'], text: dados['categoria_principal_sku']});
            abcd.push({id: dados['abcd'], text: dados['abcd']});
            subCategory.push({id: dados['sub_categoria_sku'], text: dados['sub_categoria_sku']});
            plcLocal.push({id: dados['plc_localsku'], text: dados['plc_local']});
        });
        //console.log(sku);
        this.setState({
            sku: sku,
            brand: brand,
            category: category,
            hero: hero,
            majorCategory: majorCategory,
            abcd: abcd,
            subCategory: subCategory,
            plcLocal: plcLocal
        })
    }


    handleChange = e => {
        e.persist();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
    };


    handleChange = e => {
        console.log(e);
        e.preventDefault();
        const {value, name} = e.target;
        this.setState(prevState => ({form: {...prevState.form, [name]: value}}));
    };

    render() {
        let {data, isLoading} = this.props;

        return (
            <React.Fragment>
                <Layout>
                    <Grid class="painel" fullWidth>
                        <div className="header-text">
                            <h5>Intelligent Journey</h5>
                            <h3 style={{margin: '0 0 30px'}}>Planning review</h3>
                        </div>
                        <div className="some-container">
                            <ProgressIndicator currentIndex={1}>
                                <ProgressStep
                                    label="Select"
                                    description="Step 1: Getting started with Carbon Design System"
                                    current/>
                                <ProgressStep
                                    disabled
                                    label="Edit"
                                    description="Step 5: Getting started with Carbon Design System"
                                />
                            </ProgressIndicator>
                        </div>

                        <div>
                            <Accordion data={data} isLoading={isLoading} onChange={(e) => {
                                this.handleChange(e)
                            }}/>
                        </div>
                    </Grid>
                </Layout>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({schedule}) => schedule;

const mapDispatchToProps = dispatch => ({
    fetchData: () => dispatch(schedule_get_all_filters()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Plan);
